import { useAuthContext } from "src/auth/AuthContext";
import TransfersForm from "./TransfersForm";
import { transferService } from "src/service/TransferService";

const TransfersAdd = () => {
  const { user } = useAuthContext();
  return (
    <TransfersForm
      transferId={-1}
      organizationId={user?.data?.organizationId}
      onSubmit={(ps) => transferService.add(ps).then(() => {})}
      header="Neuer Transfer"
    />
  );
};

export default TransfersAdd;
